<template>
    <div class="w-full flex justify-evenly items-center">
        <div v-for="(tab, index) in tabs" :key="index" @click="selectTab(index)"
            :class="['w-full','text-center','cursor-pointer', 'text-sm', { 'text-action border-b-3 border-action': selectedTab === index, 'border-b-1': selectedTab !== index }]">
            <p class="font-semibold">{{ tab }}</p>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const props = defineProps<{
    tabs: string[];
    selectedTab: string;
}>();

const emit = defineEmits(['tab-selected']);

const selectedTab = ref(props.tabs.indexOf(props.selectedTab));

const selectTab = (index: number) => {
    selectedTab.value = index;

    emit('tab-selected', props.tabs[index]);
};
</script>

<style scoped>
/* Add any custom styles here */
</style>